import axiosInstance from "../http/axios_instance"
const http = axiosInstance("/protected/admin",  null, "/dashboard")

const updateCredits = (obj) => http.post("/credits", obj);

export default {
    updateCredits
}